import {
  ChangeDetectionStrategy,
  ChangeDetectorRef,
  Component,
  ContentChild,
  EventEmitter,
  HostBinding,
  Input,
  OnChanges,
  OnDestroy,
  Optional,
  Output,
  SimpleChanges,
} from '@angular/core';

import { AutoHeightAnimation } from '@app/core/animations/auto-height.animation';
import { AccordionCollapsedContentDirective } from '@app/shared/modules/accordion/directives/accordion-collapsed-content.directive';
import { AccordionExpandedContentDirective } from '@app/shared/modules/accordion/directives/accordion-expanded-content.directive';
import { AccordionGroupDirective } from '@app/shared/modules/accordion/directives/accordion-group.directive';
import { AccordionHeaderDirective } from '@app/shared/modules/accordion/directives/accordion-header.directive';
import { AccordionGroupItem } from '@app/shared/modules/accordion/models/accordion.models';

@Component({
  standalone: false,
  selector: 'adspt-accordion',
  templateUrl: 'accordion.component.html',
  styleUrls: ['accordion.component.scss'],
  animations: [AutoHeightAnimation],
  changeDetection: ChangeDetectionStrategy.OnPush,
})
export class AccordionComponent implements AccordionGroupItem, OnChanges, OnDestroy {
  @ContentChild(AccordionHeaderDirective)
  header?: AccordionHeaderDirective;

  @ContentChild(AccordionCollapsedContentDirective)
  collapsedContent?: AccordionCollapsedContentDirective;

  @ContentChild(AccordionExpandedContentDirective)
  expandedContent?: AccordionExpandedContentDirective;

  @Input()
  @HostBinding('class.accordion-expanded')
  expanded: boolean = false;

  @Output()
  readonly expand = new EventEmitter<boolean>();

  @Output()
  readonly expandDone = new EventEmitter<HTMLDivElement>();

  constructor(
    private cd: ChangeDetectorRef,
    @Optional() private group: AccordionGroupDirective | null,
  ) {
    this.group?.register(this);
  }

  animationDone(ele: HTMLDivElement) {
    if (this.expanded) this.expandDone.emit(ele);
  }

  ngOnChanges(changes: SimpleChanges): void {
    if (changes.expanded?.firstChange && this.expanded) {
      this.expanded = false;
      this.toggle();
    }
  }

  toggle(): void {
    if (this.group) {
      this.group?.toggle(this);
    } else {
      this.setExpanded(!this.expanded);
    }
  }

  setExpanded(expanded: boolean): void {
    this.expanded = expanded;
    this.cd.markForCheck();

    this.expand.emit(expanded);
  }

  ngOnDestroy(): void {
    this.group?.unregister(this);
  }
}
